import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
  List,
  ListItem,
  Skeleton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import chatIcon from "../../../assets/images/chat.svg";
import {
  getPinnedPrompts,
  unpinnedPrompt,
} from "Samarth Module/api/samarthAiAPI";
import { useEffect, useMemo, useState } from "react";
import PinIcon from "../../../assets/images/pin-icon.svg";
import FillPinIcon from "../../../assets/images/fillpin.svg";
import { useLocation, useNavigate } from "react-router-dom";
const PinnedDialog = {
  "& .MuiDialog-paper": {
    maxWidth: "800px",
    borderRadius: "32px",
    position: "relative",
    pt: "25px",
    "&:before": {
      background:
        "linear-gradient(145.45deg, #FFEC9A -130.81%, #CCF0EB 50.06%, #00B2FF 188.34%)",
      width: "100%",
      height: "100%",
      content: '""',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      borderRadius: "32px",
      position: "absolute",
      top: "0",
      left: "0",
      transform: "rotate(180deg)",
    },
    "&:after": {
      background:
        "linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.6) 100%)",
      width: "100%",
      height: "100%",
      content: '""',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      borderRadius: "32px",
      position: "absolute",
      top: "0",
      left: "0",
      transform: "rotate(180deg)",
    },
  },
  "& .MuiDialogTitle-root": {
    p: "0px 32px 10px 32px",
    position: "relative",
    zIndex: 1,
  },
  "& .MuiDialogContent-root": {
    position: "relative",
    zIndex: 1,
    p: "0px 32px",
    // height: 'calc(100vh - 225px)',
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#D9E1E7",
      borderRadius: "8px",
    },
  },
};

const DialogTitles = {
  color: "#1A2025",
  fontSize: "18px",
  lineHeight: "140%",
  fontWeight: 600,
};

const chatList = {
  "& .MuiListItem-root": {
    background: "#FFFFFF",
    borderRadius: "4px",
    p: 1,
    mb: 1,
    display: "flex",
    gap: 2,
    justifyContent: "space-between",
    transition: "all 0.5s",
    cursor: "pointer",
    "&:hover": {
      background: "#F0F7FF",
      "& .actions": {
        opacity: 1,
      },
    },
  },
  "& .actions": {
    opacity: 0,
    display: "flex",
    gap: 1,
    transition: "all 0.5s",
  },
  "& .MuiTypography-body1": {
    color: "#4D5F6E",
    fontSize: "14px",
    lineHeight: "140%",
    fontWeight: 400,
  },
};
  const tooltipProps = {
    slotProps: {
      tooltip: {
        sx: {
          backgroundColor: "#F6F7F0 !important",
          color: "#1A2025",
          fontSize: "12px",
          p: "3px 16px !important",
        },
      },
    },
  };

const ChatListItem = ({
  text,
  onChatClick,
  onPinClick,
  chatIcon,
  isPinned,
}) => {
  return (
    <ListItem onClick={onChatClick}>
      <Typography variant="body1">{text}</Typography>
      <Box display="flex" gap={1} className="actions">
        <Tooltip title="Start Chat" placement="top" {...tooltipProps}>
          <Box
            component="img"
            src={chatIcon}
            onClick={onChatClick}
            sx={{ cursor: "pointer", width: 20, height: 20 }}
          />
        </Tooltip>
        <Tooltip
          title={isPinned ? "Pinned" : "Pin"}
          placement="top"
          {...tooltipProps}
        >
          <Box
            component="img"
            src={isPinned ? FillPinIcon : PinIcon}
            onClick={(e) => {
              e.stopPropagation();
              onPinClick();
            }}
            sx={{ cursor: "pointer", width: 20, height: 20 }}
          />
        </Tooltip>
      </Box>
    </ListItem>
  );
};
function PinnedPromptsDialog({ open, onClose, drawerClose, isState }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("UserInfo"))?.user_info,
    [],
  );
  const fetchPinnedPrompts = async () => {
    try {
      setLoading(true);

      const { data } = await getPinnedPrompts({
        user_id: userInfo.id,
        user_name: userInfo.name,
        user_email: userInfo.email,
      });
      const formatted = (data?.pinned_prompts || []).map((msg) => ({
        id: msg.message_id,
        text: msg.message,
        is_pinned: true,
        created_at: msg.timestamp,
      }));

      setMessages(formatted);
    } catch (err) {
      console.error("Failed to fetch pinned prompts", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchPinnedPrompts();
    }
  }, [open]);
  const handlePinClick = async (msg) => {
    const payload = {
      user_id: userInfo.id,
      user_name: userInfo.name,
      user_email: userInfo.email,
      message_id: msg.id,
    };

    setMessages((prev) => prev.filter((m) => m.id !== msg.id));

    try {
      await unpinnedPrompt(payload);
    } catch (err) {
      console.error(err);
      fetchPinnedPrompts();
    }
  };
  const handleChatClick = (text) => {
    if (!isState) {
      navigate("/samarth/chat", {
        state: { reset: true, message: text },
        replace: true,
      });
      onClose();
    } else {
      navigate(location.pathname, {
        state: { reset: true, message: text },
        replace: true,
      });
      drawerClose();
      onClose();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={PinnedDialog}
    >
      <DialogTitle
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography sx={DialogTitles}>Pinned Prompts</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon sx={{ color: "#0066CC" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <List sx={chatList}>
            {[1, 2, 3].map((i) => (
              <ListItem key={i}>
                <Skeleton variant="text" width="80%" height={30} />
              </ListItem>
            ))}
          </List>
        ) : messages.length === 0 ? (
          <Typography variant="body1" textAlign="center" mb="32px">
            No pinned prompts
          </Typography>
        ) : (
          <List sx={chatList}>
            {messages.map((msg) => (
              <ChatListItem
                key={msg.id}
                text={msg.text}
                chatIcon={chatIcon}
                isPinned={msg.is_pinned}
                onChatClick={() => handleChatClick(msg.text)}
                onPinClick={() => handlePinClick(msg)}
              />
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default PinnedPromptsDialog;
